import { render, staticRenderFns } from "./baseTable.vue?vue&type=template&id=bf0b9522&"
import script from "./baseTable.vue?vue&type=script&lang=ts&"
export * from "./baseTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports